import App from "./App.vue";
import router from "./router";
import { setupStore } from "@/store";
import ElementPlus from "element-plus";
import { getServerConfig } from "./config";
import { createApp, Directive } from "vue";
import { MotionPlugin } from "@vueuse/motion";
// import { useEcharts } from "@/plugins/echarts";

import { injectResponsiveStorage } from "@/utils/responsive";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import JsonViewer from "vue-json-viewer";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";

// import Table from "@pureadmin/table";
// import PureDescriptions from "@pureadmin/descriptions";

// 引入重置样式
import "./style/reset.scss";
// 导入公共样式
import "./style/index.scss";
// 一定要在main.ts中导入tailwind.css，防止vite每次hmr都会请求src/style/index.scss整体css文件导致热更新慢的问题
import "./style/tailwind.css";
import "element-plus/dist/index.css";
// import formCreate from "@form-create/element-ui";
import FcDesigner from "./utils/formCreate/index.es.js";
import fp from "@/views/business/editor/components/formPicker.vue";
// 注入自定义的按钮
FcDesigner.component("chooseBtn", fp);
// 导入字体图标
import "./assets/iconfont/iconfont.js";
import "./assets/iconfont/iconfont.css";
// webSocket引入
import webSocketService from "@/utils/socket";

const app = createApp(App);
// 添加图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
// 自定义指令
import * as directives from "@/directives";
Object.keys(directives).forEach((key) => {
  app.directive(key, (directives as { [key: string]: Directive })[key]);
});
// 全局挂载webSocket
app.provide("$socket", webSocketService);
// 全局注册`@iconify/vue`图标库
import { IconifyIconOffline, IconifyIconOnline, FontIcon } from "./components/ReIcon";
app.component("IconifyIconOffline", IconifyIconOffline);
app.component("IconifyIconOnline", IconifyIconOnline);
app.component("FontIcon", FontIcon);

// 全局注册按钮级别权限组件
import { Auth } from "@/components/ReAuth";
import { Logger } from "sass";
app.component("Auth", Auth);

getServerConfig(app)
  .then(async (config) => {
    app.use(router);
    await router.isReady();
    injectResponsiveStorage(app, config);
    setupStore(app);
    app.use(MotionPlugin).use(ElementPlus).use(FcDesigner.formCreate).use(FcDesigner).use(JsonViewer);
    // .use(useEcharts);
    // .use(Table);
    // .use(PureDescriptions);
    app.use(Antd);
    app.mount("#app");
  })
  .catch((err) => {
    console.error("应用初始化失败:", err);
    const appEl = document.getElementById("app");
    if (appEl) {
      appEl.innerHTML = `
        <div style="text-align:center;padding:40px;color:#666;font-size:14px;">
          <p>页面加载失败，请尝试刷新页面</p>
          <p style="font-size:12px;color:#999;margin-top:10px;">${err?.message || err || "未知错误"}</p>
        </div>
      `;
    }
  });
